export const locale = {
    lang: 'es',
    data: {
        'PROFILE': {
            'ACTUALIZAR': 'ACTUALIZAR',
            'PAYMENT': 'Método de Pago',
            'PAYMENTNEW': 'Va a actualizar el Método de Pago',
            'CARD': 'Datos de la Tarjeta',
            'DATOS_PERSONALES': 'Datos Personales',
            'PASSWORD_TAB': 'Seguridad',
            'PASSWORD_TITLE': 'CAMBIO CONTRASEÑA',
            'PASSWORD_OLD': 'Contraseña anterior',
            'PASSWORD_NEW': 'Nueva Contraseña',
            'EMAIL': 'Correo electrónico',
            'EMAIL_REQUIRED': 'El correo electrónico es obligatorio',
            'EMAIL_NOT_VALID': 'Por favor, introduce un correo electrónico válido',
            'PASSWORD': 'Contraseña',
            'PASSWORD_REQUIRED': 'La contraseña es obligatoria',
            'PASSWORD_CONFIRMATION': 'Contraseña (confirmación)',
            'PASSWORD_CONFIRMATION_REQUIRED': 'La confirmación de la contraseña es obligatoria',
            'PASSWORD_CONFIRMATION_MATCH': 'Las contraseñas deben coincidir',
            'BUSINESS_NAME': 'Razón Social',
            'BUSINESS_NAME_REQUIRED': 'La razón social es obligatoria',
            'VAT_NUMBER': 'CIF',
            'VAT_NUMBER_REQUIRED': 'El CIF es obligatorio',
            'PHONE_1': 'Teléfono 1',
            'PHONE_1_REQUIRED': 'El teléfono 1 es obligatorio',
            'PHONE_2': 'Teléfono 2 (opcional)',
            'TRADENAME': 'Nombre Comercial',
            'TRADENAME_REQUIRED': 'El nombre comercial es obligatorio',
            'BILLING_ADDRESS': 'Dirección de Facturación',
            'BILLING_ADDRESS_REQUIRED': 'La dirección de facturación es obligatoria',
            'WEB': 'Web (opcional)',
            'PROMOTIONAL_CODE': 'Promotional code (opcional)',
            'READ_AND_ACCEPT': 'He leído y acepto los',
            'TEMRS_AND_CONDITIONS': 'términos y condiciones',
            'HAVE_ACCOUNT': '¿Ya tiene una cuenta registrada?',
            'LOGIN': 'Iniciar Sesión',
            'PAYMENT_CARD_NUMBER': 'Número de tarjeta',
            'PAYMENT_CARD_MONTH': 'Mes de caducidad',
            'PAYMENT_CARD_YEAR': 'Año de caducidad',
            'PAYMENT_CARD_CVV': 'CVV',
            'PAYMENT_ADVISE': '*El cobro se realizará tras el mes de prueba',
            'CONTACT_DATA': 'Datos de contacto (opcional)',
            'CONTACT_NAME': 'Nombre de contacto',
            'CONTACT_EMAIL': 'Email de contacto',
            'PAYMENT_CARD_NOT_VALID': 'Número de tarjeta no válido',
            'CARD_YEAR_REQUIRED': 'El año es obligatorio',
            'PAYMENT_CARD_YEAR_NOT_VALID': 'El año introducido no es válido',
            'PAYMENT_CARD_DATE_NOT_VALID': 'La fecha no es válida',
            'CARD_MONTH_REQUIRED': 'El mes es obligatorio',
            'PAYMENT_CARD_MONTH_NOT_VALID': 'El mes introducido no es válido',
            'CARD_NUMBER_REQUIRED': 'El número es obligatorio',
            'CARD_CVV_REQUIRED': 'El CVV es obligatorio',
            'SUBSCRIPTION':'Ir a Mi Suscripcion',
            'PAYMENTBAD':'No se ha podido actualizar los datos. Compruébelos.',
            
        },
        'REGISTER': {
            'TITLE': 'DATOS PERSONALES',
            'ACTUALIZAR': 'ACTUALIZAR DATOS',
            
            'EMAIL': 'Correo electrónico',
            'EMAIL_REQUIRED': 'El correo electrónico es obligatorio',
            'EMAIL_NOT_VALID': 'Por favor, introduce un correo electrónico válido',
            'PASSWORD': 'Contraseña',
            'PASSWORD_REQUIRED': 'La contraseña es obligatoria',
            'PASSWORD_CONFIRMATION': 'Contraseña (confirmación)',
            'PASSWORD_CONFIRMATION_REQUIRED': 'La confirmación de la contraseña es obligatoria',
            'PASSWORD_CONFIRMATION_MATCH': 'Las contraseñas deben coincidir',
            'BUSINESS_NAME': 'Razón Social',
            'BUSINESS_NAME_REQUIRED': 'La razón social es obligatoria',
            'VAT_NUMBER': 'CIF (solo lectura )',
            'VAT_NUMBER_REQUIRED': 'El CIF es obligatorio',
            'PHONE_1': 'Teléfono 1',
            'PHONE_1_REQUIRED': 'El teléfono 1 es obligatorio',
            'PHONE_2': 'Teléfono 2 (opcional)',
            'TRADENAME': 'Nombre Comercial',
            'TRADENAME_REQUIRED': 'El nombre comercial es obligatorio',
            'BILLING_ADDRESS': 'Dirección de Facturación',
            'BILLING_ADDRESS_REQUIRED': 'La dirección de facturación es obligatoria',
            'WEB': 'Web (opcional)',
            'PROMOTIONAL_CODE': 'Promotional code (opcional)',
            'READ_AND_ACCEPT': 'He leído y acepto los',
            'TEMRS_AND_CONDITIONS': 'términos y condiciones',
            'HAVE_ACCOUNT': '¿Ya tiene una cuenta registrada?',
            'LOGIN': 'Iniciar Sesión',
            'PAYMENT_CARD_NUMBER': 'Número de tarjeta',
            'PAYMENT_CARD_MONTH': 'Mes de caducidad',
            'PAYMENT_CARD_YEAR': 'Año de caducidad',
            'PAYMENT_CARD_CVV': 'CVV',
            'PAYMENT_ADVISE': '*El cobro se realizará tras el mes de prueba',
            'CONTACT_DATA': 'Datos de contacto (opcional)',
            'CONTACT_NAME': 'Nombre de contacto',
            'CONTACT_EMAIL': 'Email de contacto',
            'PAYMENT_CARD_NOT_VALID': 'Número de tarjeta no válido',
            'CARD_YEAR_REQUIRED': 'El año es obligatorio',
            'PAYMENT_CARD_YEAR_NOT_VALID': 'El año introducido no es válido',
            'PAYMENT_CARD_DATE_NOT_VALID': 'La fecha no es válida',
            'CARD_MONTH_REQUIRED': 'El mes es obligatorio',
            'PAYMENT_CARD_MONTH_NOT_VALID': 'El mes introducido no es válido',
            'CARD_NUMBER_REQUIRED': 'El número es obligatorio',
            'CARD_CVV_REQUIRED': 'El CVV es obligatorio'
        }
    }
};
